import { render, staticRenderFns } from "./DodajPridelovalca.vue?vue&type=template&id=6eb223c3&"
import script from "./DodajPridelovalca.vue?vue&type=script&lang=js&"
export * from "./DodajPridelovalca.vue?vue&type=script&lang=js&"
import style0 from "./DodajPridelovalca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports